import { createAction } from '@reduxjs/toolkit';

/**
 * Clears persisted admin org-setup journey (flow / payroll / plan / auth slice mirrors).
 * Dispatch on admin logout or admin session expiry so the next login starts at select/create org.
 */
export const resetAdminPersistedJourneyState = createAction('admin/resetPersistedJourneyState');
